import React from "react"
import useStore from "../../utils/useStore"

const MCQComponent = React.memo(({ item, isFullScreen, answers }) => {
    const selects = useStore((state) => state.selects)
    const selected = selects?.find((e) => e === item?.id)
    const editElements = useStore((state) => state.editElements)
    const addSelects = useStore((state) => state.addSelects)
    const setClickedPosition = useStore((state) => state.setClickedPosition)
    const setDragging = useStore((state) => state.setDragging)
    const dragging = useStore((state) => state.dragging)
    const setResizing = useStore((state) => state.setResizing)
    const resizing = useStore((state) => state.resizing)
    const editing = useStore((state) => state.editing)
    const setEditing = useStore((state) => state.setEditing)

    const onMouseDown = (event) => {
        window.getSelection().removeAllRanges()
        addSelects(item?.id)
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        setClickedPosition({ x: event.clientX, y: event.clientY })
        if (!selected && editing) {
            setEditing(false)
            setTimeout(() => {
                setDragging(true)
            }, 50);
        } else if (!selected) {
            setDragging(true)
        }
    }

    const onMouseHandleDown = (event, cursor, side) => {
        event.stopPropagation()
        window.getSelection().removeAllRanges()
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        setResizing({ cursor: cursor, side })
        setClickedPosition({ x: event.clientX, y: event.clientY })
    }

    const totalAnswers = answers?.length;

    const answerCounts = item?.options?.map(option =>
        answers?.filter(answer => answer?.answer === option)?.length
    );

    const percentages = answerCounts?.map(count => (count / totalAnswers) * 100);

    function roundNumber(num) {
        if (num % 1 === 0) {
          return num;
        } else {
          return num.toFixed(1);
        }
      }

    return (
        <div className={selected && !isFullScreen ? 'Presentation_Inter_Select Presentation_Inter_Selected' : 'Presentation_Inter_Select'} style={{ position: "absolute", pointerEvents: isFullScreen ? "none" : "", transform: `translate(${item?.currPosition?.x}px, ${item?.currPosition?.y}px)`, cursor: resizing ? resizing?.cursor : dragging ? "move" : "default", userSelect: "none" }} onMouseDown={onMouseDown} onClick={(event) => {
            event.stopPropagation()
            if (!selected) {
                addSelects(item?.id)
            }
        }}>
            <div style={{ ...item?.style, overflow: "hidden" }}>
                <div className='Presentation_Inter_Title'>{item?.title}</div>
                <div className='Presentation_Inter_Chart_Con'>
                    <div className='Presentation_Inter_Chart_Bar_Con'>
                        {item?.options?.map((itm, ind) => {
                            const values = isFullScreen ? percentages : item?.sampleValues
                            return (
                                <div className='Presentation_Inter_Chart_Bar_Outer' key={ind}>
                                    <div className='Presentation_Inter_Chart_Bar_Text'>{roundNumber(values[ind] || 0) || 0}%</div>
                                    <div style={{ height: `${values[ind] || 0}%` }} className='Presentation_Inter_Chart_Bar' />
                                </div>
                            )
                        })}
                    </div>
                    <div className='Presentation_Inter_Chart_Footer'>
                        {item?.options?.map((itm, ind) => {
                            return <div className='Presentation_Inter_Chart_Footer_Text' key={ind}>{itm}</div>
                        })}
                    </div>
                </div>
            </div>
            {selected && !dragging && !isFullScreen ?
                <>
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LT' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "top-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LB' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "bottom-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RT' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "top-right")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RB' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "bottom-right")} />
                </>
                : null}
        </div>
    )
})

export default MCQComponent;